import { renderSlot } from 'vue';
import _export_sfc from './basler-components.es343.js';

const _sfc_main = {};

function _sfc_render(_ctx, _cache) {
  return renderSlot(_ctx.$slots, "default", { attrs: _ctx.$attrs })
}
const RenderlessComponent = /*#__PURE__*/_export_sfc(_sfc_main, [['render',_sfc_render]]);

export { RenderlessComponent as default };
